import { useNavigate } from "react-router-dom";
import { Card } from "@/components/ui/card";
import { ShopifyProduct } from "@/lib/shopify";
import { useCurrency } from "@/hooks/useCurrency";

interface ProductCardProps {
  product: ShopifyProduct;
}

export const ProductCard = ({ product }: ProductCardProps) => {
  const navigate = useNavigate();
  const { convertPrice } = useCurrency();
  const displayImage = product.node.images.edges[0]?.node.url || "";
  const minPrice = parseFloat(product.node.priceRange.minVariantPrice.amount);
  const currencyCode = product.node.priceRange.minVariantPrice.currencyCode;

  return (
    <Card className="overflow-hidden hover:shadow-lg transition-shadow">
      <div 
        className="aspect-square bg-secondary/20 overflow-hidden cursor-pointer"
        onClick={() => navigate(`/product/${product.node.handle}`)}
      >
        {displayImage ? (
          <img
            src={displayImage}
            alt={product.node.title}
            className="w-full h-full object-cover hover:scale-105 transition-transform duration-300"
          />
        ) : (
          <div className="w-full h-full flex items-center justify-center text-muted-foreground">
            No image
          </div>
        )}
      </div>
      
      <div className="p-4 space-y-2">
        <h3 
          className="font-semibold text-lg line-clamp-2 cursor-pointer hover:text-primary transition-colors"
          onClick={() => navigate(`/product/${product.node.handle}`)}
        >
          {product.node.title}
        </h3>
        
        <div className="space-y-1">
          <p className="text-xl font-bold text-primary">
            {currencyCode} ${minPrice.toFixed(2)}
          </p>
          <p className="text-sm text-muted-foreground">
            AUD ${convertPrice(minPrice).toFixed(2)}
          </p>
        </div>

        <p className="text-sm text-muted-foreground">
          Click to view options and add to cart
        </p>
      </div>
    </Card>
  );
};
